import { render } from "./account-mapping-page-header.vue?vue&type=template&id=c4725e8b&scoped=true"
import script from "./account-mapping-page-header.vue?vue&type=script&lang=js"
export * from "./account-mapping-page-header.vue?vue&type=script&lang=js"

import "./account-mapping-page-header.vue?vue&type=style&index=0&id=c4725e8b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4725e8b"]])

export default __exports__